import { Col, Row } from 'antd';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

type Props = {
  current: number;
};
function ShopOrderStep({ current }: Props) {
  return (
    <div className='shop-order-step'>
      <Row className='bg-white'>
        <Col xs={24} md={8}>
          <div className={`step-block ${classNames({ active: current === 1 })}`}>
            <div className='step'>
              <h2>
                <FormattedMessage id='app.common.cart' defaultMessage='Shopping Cart' />
              </h2>
              <span>01</span>
            </div>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div className={`step-block ${classNames({ active: current === 2 })}`}>
            <div className='step'>
              <h2>
                <FormattedMessage id='app.common.checkout' defaultMessage='Checkout' />
              </h2>
              <span>02</span>
            </div>
          </div>
        </Col>
        <Col xs={24} md={8}>
          <div className={`step-block ${classNames({ active: current === 3 })}`}>
            <div className='step'>
              <h2>
                <FormattedMessage id='app.common.order_complete' defaultMessage='Order Complete' />
              </h2>
              <span>03</span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ShopOrderStep;
